import { type LabelComponentType, getLabelComponent } from "../../../../common-deprecated/components/label/Label";
import {
    type GetLabelType,
    type GetOptionalLabelType,
    type UseLabelType,
    type UseOptionalLabelType,
    getLabelFn,
    getOptionalLabelFn,
    getUseLabel,
    getUseOptionalLabel,
} from "../../../../common-deprecated/hooks/useLabel";
import type { CommonSettingsType } from "../../../../common-deprecated/settings/fetchCommonSettings";
import type { RetailerSettingsType } from "../redux/RetailerSettingsSlice";

export const retailerLabels = {
    retailerScreenNavBack: "Back",
    retailerScreenNavHome: "Home",
    retailerScreenNavLoadConfig: "Load your configuration",
    retailerScreenNavNeedHelp: "Need help?",
    retailerScreenYourCode: "Your code",
    retailerScreenYourCodeIntro:
        "Did you already configure your vehicle at home? Enter your unique code here, and continue the journey.",
    retailerScreenYourCodeLabel: "Enter code",
    retailerScreenYourCodeFieldLabel: "Code",
    retailerScreenYourCodeError: "Something went wrong while loading your configuration",
    retailerScreenEnterYourCode: "Enter your configuration code",
    retailerScreenLoadConfig: "Load configuration",
    retailerScreenQrCodeSubText: "This unique code lets you view and amend your saved cars at any Lexus Centre.",
    retailerScreenWhatsNext: "What's next?",
    retailerScreenQrCodeSteps:
        "Talk to your retailer for more information on purchase and financing options. Scan the QR code with your smartphone and view this car when and where it suits you",
    retailerScreenExternalQrTitle: "Open link",
    retailerScreenExternalQrDescription: "Scan the QR code to view this info on your mobile device.",
    retailerScreenExternalQrBackCTA: "Back",
};

// ----------------------------------------------------------------------
// Helpers
// ----------------------------------------------------------------------

type RetailerLabelStateType = { commonSettings: CommonSettingsType; retailerSettings: RetailerSettingsType };
export type RetailerLabelType = keyof typeof retailerLabels;
type RetailerLabelParamType = Partial<Record<"value", string | number>>;

export const useRetailerLabel = getUseLabel(
    (state: RetailerLabelStateType) => state.retailerSettings.labels,
    (state: RetailerLabelStateType) => !!state.commonSettings.query.showDictionaryKeys,
) as UseLabelType<RetailerLabelType, RetailerLabelParamType>;

export const useRetailerOptionalLabel = getUseOptionalLabel(
    (state: RetailerLabelStateType) => state.retailerSettings.labels,
    (state: RetailerLabelStateType) => !!state.commonSettings.query.showDictionaryKeys,
) as UseOptionalLabelType<RetailerLabelType, RetailerLabelParamType>;

export const getRetailerLabel = getLabelFn(
    (state: RetailerLabelStateType) => state.retailerSettings.labels,
    (state: RetailerLabelStateType) => !!state.commonSettings.query.showDictionaryKeys,
) as GetLabelType<RetailerLabelStateType, RetailerLabelType, RetailerLabelParamType>;

export const getRetailerOptionalLabel = getOptionalLabelFn(
    (state: RetailerLabelStateType) => state.retailerSettings.labels,
    (state: RetailerLabelStateType) => !!state.commonSettings.query.showDictionaryKeys,
) as GetOptionalLabelType<RetailerLabelStateType, RetailerLabelType, RetailerLabelParamType>;

export const RetailerLabel = getLabelComponent(useRetailerLabel) as LabelComponentType<
    RetailerLabelType,
    RetailerLabelParamType
>;
